// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.leader-details .el-textarea.is-disabled .el-textarea__inner {\n  font-family:\n    'Noto Sans TC',\n    sans-serif,\n    Arial,\n    Microsoft JhengHei !important;\n  font-size: 1.1rem;\n  line-height: 1.75;\n  color: #1a1a1a;\n  font-weight: 300;\n  /* font-size: 17px; */\n  background-color: snow;\n  border-color: #dfe4ed;\n  color: steelblue !important;\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
